(function() {
  var SHOP = "https://interiorstein.no";
  var QRL = {
    cc:   SHOP + "/products/akemi-crystal-clean-sprayflaske?_pos=1&_psq=crysta&_ss=e&_v=1.0",
    te:   SHOP + "/products/akemi-trippel-effect?_pos=1&_sid=9fa213e6c&_ss=r",
    sc:   SHOP + "/products/akemi-steinrengjoring?_pos=1&_sid=b37850766&_ss=r",
    ic:   SHOP + "/products/akemi-intensivrengjoring?_pos=1&_sid=d5a9998c0&_ss=r",
    gbs:  SHOP + "/products/good-bye-stain-akemi?_pos=1&_psq=good+bye&_ss=e&_v=1.0",
    ogp:  SHOP + "/products/akemi-olje-og-fettfjernepasta?_pos=1&_sid=4e1d620d",
    rm:   SHOP + "/products/akemi-rustfjerner-for-marmor-og-kalkstein?_pos=1&_sid=45465cc52&_ss=r",
    ps:   "https://stein.akemi.de/en/productfinder/protect-care/produktdetail-en/pro-scrub__3587__/",
    impr: SHOP + "/products/akemi-nano-impregnering?_pos=1&_sid=c0b4c852d&_ss=r",
    fd:   SHOP + "/products/akemi-fargeforsterker?_pos=1&_psq=fargeforst&_ss=e&_v=1.0",
    sd:   SHOP + "/products/akemi-superdark?_pos=1&_sid=f83203205&_ss=r",
    qp:   SHOP + "/products/kvarts-polish?_pos=2&_psq=kvart&_ss=e&_v=1.0",
    guide:SHOP + "/en/pages/akemi-flekkfjerning"
  };
  var QRL_LABELS = {
    cc:"Crystal Clean", te:"Triple Effect", sc:"Stenrens", ic:"Intensiv Cleaner",
    gbs:"Good Bye Stain", ogp:"Olje & Fettfjernepasta", rm:"Rustfjerner marmor",
    ps:"ProScrub", impr:"Impregnator Pro", fd:"Fargeforsterker", sd:"Superdark", qp:"Quartz Polish"
  };

  function pt(label, key) {
    return '<span class="fdv-ptag"><a href="' + QRL[key] + '" target="_blank">' + label + '</a></span>';
  }
  var P = {
    cc:  pt("Akemi Crystal Clean",           "cc"),
    te:  pt("Akemi Triple Effect",           "te"),
    sc:  pt("Akemi Stenrens",                "sc"),
    ic:  pt("Akemi Intensiv Cleaner",        "ic"),
    gbs: pt("Akemi Good Bye Stain",          "gbs"),
    ogp: pt("Akemi Olje &amp; Fettfjernepasta","ogp"),
    rm:  pt("Akemi Rustfjerner til marmor",  "rm"),
    ps:  '<span class="fdv-ptag"><a href="' + QRL.ps + '" target="_blank">Akemi ProScrub</a></span>',
    impr:pt("Akemi Nano Impregnering",         "impr"),
    fd:  pt("Akemi Fargeforsterker",         "fd"),
    sd:  pt("Akemi Superdark",               "sd"),
    qp:  pt("Akemi Quartz Polish",           "qp")
  };
  var PS_DESC = P.ps + " \u2014 til fjerning av metallavsetninger og aluminiumsriper p\u00e5 Dekton, porselen og keramiske materialer";

  var MATS = [
    {id:"lys_marmor",   name:"Lys marmor",          tag:"Naturstein",       type:"naturstein"},
    {id:"mork_marmor",  name:"M\u00f8rk marmor",    tag:"Naturstein",       type:"naturstein"},
    {id:"svart_marmor", name:"Svart marmor",         tag:"Naturstein",       type:"naturstein"},
    {id:"brun_og_graa_marmor",  name:"Brun og graa marmor",          tag:"Naturstein",       type:"naturstein"},
    {id:"granitt",      name:"Granitt",              tag:"Naturstein",       type:"naturstein"},
    {id:"skifer",       name:"Skifer utend\u00f8rs", tag:"Naturstein",       type:"naturstein"},
    {id:"silestone",    name:"Silestone",            tag:"Kvarts kompositt", type:"kompositt"},
    {id:"caesarstone",  name:"Caesarstone",          tag:"Kvarts kompositt", type:"kompositt"},
    {id:"dekton",       name:"Dekton",               tag:"Ultra-kompakt",    type:"ultrakomp"},
    {id:"porcelanosa",  name:"Porcelanosa keramikk", tag:"Keramikk",         type:"keramikk"},
    {id:"laminam",      name:"Laminam keramikk",     tag:"Keramikk",         type:"keramikk"}
  ];

  var FDV = {
    lys_marmor: {
      display:"Lys marmor", hardhet:"Lav\u2013middels (Mohs 3\u20134)", varmeTaal:"Begrenset \u2014 bruk alltid gryteunderlag",
      ph:"pH 7\u20139 (svakt alkalisk)", imprTekst:P.impr+" hvert 6\u201312 mnd \u2014 "+P.fd+" hvis \u00f8nsket dypere tone",
      daglig:["Spray "+P.cc+" p\u00e5 flaten og t\u00f8rk av med ren mikrofiberklut","Fjern umiddelbart s\u00f8l av syre (sitrus, eddik, vin)"],
      ukentlig:["P\u00e5f\u00f8r "+P.te+" \u2014 rengj\u00f8r, impregnerer og gjenoppretter glans i \u00e9n operasjon","Inspiser at vannd\u00e5per fortsatt perler (tegn p\u00e5 aktiv impregnering)"],
      arlig:["Grunnrengj\u00f8ring med "+P.sc,"P\u00e5f\u00f8r ny "+P.impr+" eller "+P.fd+" etter grundig rengj\u00f8ring","Kontakt fagperson ved etse-skader eller dype flekker"],
      flekk:[
        {type:"Organisk farge (kaffe, r\u00f8dvin, te, frukt)", middel:P.gbs+" \u2014 p\u00e5f\u00f8r, la virke 10\u201330 min, skyll grundig", pill:"warn"},
        {type:"Olje- og fettflekker (trukket inn)", middel:P.ogp+" \u2014 p\u00e5f\u00f8r som 1\u20132 mm tykt lag, dekk til, la virke 30\u201360 min, b\u00f8rst av", pill:"warn"},
        {type:"Rustflekker", middel:P.rm+" \u2014 spesialformulert for marmor og syrefs\u00f8lsom stein", pill:"danger"},
        {type:"Kalkbelegg (vann)", middel:P.sc+" kortvarig \u2014 skyll grundig", pill:"info"}
      ],
      advarsel:"Lys marmor er kalkstein \u2014 reagerer med all syre. Unng\u00e5 eddik, sitrus, Klorin og skurende midler. T\u00f8rk opp syre umiddelbart.",
      foerVar:["Bruk alltid skj\u00e6ref\u00f8l \u2014 aldri bruk skarpe kniver direkte p\u00e5 flaten","Bruk gryteunderlag \u2014 marmor t\u00e5ler ikke varmt direkte","Dekk til benken under matlaging med syreholdig mat","Impregner hyppig \u2014 lys marmor er por\u00f8s og absorberer lett","L\u00f8ft \u2014 ikke skyv \u2014 tunge gjenstander for \u00e5 unng\u00e5 riper"],
      qrKeys:["cc","te","sc","impr","fd","gbs","ogp","rm"]
    },
    mork_marmor: {
      display:"M\u00f8rk marmor", hardhet:"Lav\u2013middels (Mohs 3\u20134)", varmeTaal:"Begrenset \u2014 bruk alltid gryteunderlag",
      ph:"pH 7\u20139 (svakt alkalisk)", imprTekst:P.sd+" \u2014 forsterker og bevarer m\u00f8rk tone, hvert 6 mnd",
      daglig:[P.cc+" daglig \u2014 t\u00f8rk i \u00e9n retning for \u00e5 unng\u00e5 striper","Fjern kalkdr\u00e5per fra vann umiddelbart \u2014 synes sv\u00e6rt godt p\u00e5 m\u00f8rk flate"],
      ukentlig:[P.te+" ukentlig \u2014 rengj\u00f8ring, beskyttelse og glans i \u00e9n operasjon","T\u00f8rk grundig etter rengj\u00f8ring \u2014 kalkholdige vannd\u00e5per misfarger m\u00f8rk stein"],
      arlig:["Grunnrengj\u00f8ring med "+P.sc,"Ny "+P.sd+" impregnering \u2014 gir dybde og beskyttelse","Profesjonell polering ved behov"],
      flekk:[
        {type:"Organisk farge (kaffe, vin, fruktjuice)", middel:P.gbs+" \u2014 aktivklorbasert, fjerner organisk misfarging raskt", pill:"warn"},
        {type:"Olje- og fettflekker (trukket inn)", middel:P.ogp+" \u2014 kremet poultis med absorberingsmiddel", pill:"warn"},
        {type:"Rustflekker", middel:P.rm+" \u2014 egnet for syrefs\u00f8lsom stein", pill:"danger"}
      ],
      advarsel:"M\u00f8rk marmor viser kalkmerker, fingeravtrykk og striper ekstremt tydelig. Hyppig t\u00f8rking er n\u00f8kkelen. Syre er kritisk \u2014 null toleranse.",
      foerVar:["T\u00f8rk alltid etter vannkontakt \u2014 kalkavleiringer er sv\u00e6rt synlige","Bruk Akemi Superdark som impregnering \u2014 gir farge og beskyttelse","Ha alltid mikrofiberklut tilgjengelig","Unng\u00e5 absolutt all syre","Vurder daglig polish for \u00e5 opprettholde glans"],
      qrKeys:["cc","te","sc","sd","gbs","ogp","rm"]
    },
    svart_marmor: {
      display:"Svart marmor", hardhet:"Lav\u2013middels (Mohs 3\u20134)", varmeTaal:"Begrenset \u2014 bruk alltid gryteunderlag",
      ph:"pH 7\u20139 (svakt alkalisk)", imprTekst:P.sd+" \u2014 anbefalt for \u00e5 bevare og forsterke den m\u00f8rke tonen, hvert 6 mnd",
      daglig:[P.cc+" daglig \u2014 t\u00f8rk i \u00e9n retning for \u00e5 unng\u00e5 striper og fingeravtrykk","Fjern alle vannd\u00e5per \u2014 kalk og fingeravtrykk synes ekstremt godt"],
      ukentlig:[P.te+" \u2014 rengj\u00f8ring, impregnering og glansrestitusjon kombinert","Aktiv t\u00f8rking etter rengj\u00f8ring"],
      arlig:["Grunnrengj\u00f8ring med "+P.sc,P.sd+" \u2014 gjenoppretter dybde og farge","Fagperson ved etse-skader"],
      flekk:[
        {type:"Organisk farge", middel:P.gbs+" \u2014 raskt og effektivt p\u00e5 fruktjuice, vin, kaffe", pill:"warn"},
        {type:"Olje og fett (trukket inn)", middel:P.ogp+" \u2014 kremet poultis, la virke 30\u201360 min", pill:"warn"},
        {type:"Kalk/vannmerker", middel:P.sc+" kortvarig \u2014 skyll grundig", pill:"info"},
        {type:"Rustflekker", middel:P.rm, pill:"danger"}
      ],
      advarsel:"Svart marmor er det mest krevende alternativet vedlikeholdsmessig. Enhver flekk, kalkmerke eller fingeravtrykk er sv\u00e6rt synlig. Krever hyppig og konsekvent pleie.",
      foerVar:["T\u00f8rk alltid overflaten etter bruk \u2014 aldri la vann st\u00e5","Impregner hvert halv\u00e5r minimum med Superdark","Unng\u00e5 absolutt all syre og syreholdig mat","Vurder matt finish i stedet for polert \u2014 skjuler fingeravtrykk bedre","Ha alltid mikrofiberklut tilgjengelig p\u00e5 benken"],
      qrKeys:["cc","te","sc","sd","gbs","ogp","rm"]
    },
    brun_og_graa_marmor: {
      display:"Brun marmor", hardhet:"Lav\u2013middels (Mohs 3\u20134)", varmeTaal:"Begrenset \u2014 bruk alltid gryteknderlag",
      ph:"pH 7\u20139 (svakt alkalisk)", imprTekst:P.fd+" \u2014 beriker og bevarer den varme tonen, hvert 6\u201312 mnd",
      daglig:[P.cc+" \u2014 daglig lett rengj\u00f8ring, syrefri og matvareegnet","T\u00f8rk s\u00f8l umiddelbart, spesielt organisk og syreholdig"],
      ukentlig:[P.te+" ukentlig for kombinert rengj\u00f8ring, impregnering og glans","Kontroller at impregneringen er aktiv"],
      arlig:["Grunnrengj\u00f8ring med "+P.sc,P.fd+" impregnering \u2014 beskytter og beriker tonen"],
      flekk:[
        {type:"Organisk farge (kaffe, vin)", middel:P.gbs+" \u2014 aktiv klorbasert flekkfjerner", pill:"warn"},
        {type:"Olje og fett", middel:P.ogp+" \u2014 p\u00e5f\u00f8r som asta, la absorbere", pill:"warn"},
        {type:"Rustflekker", middel:P.rm+" \u2014 sk\u00e5nsom for syrefs\u00f8lsom stein", pill:"danger"}
      ],
      advarsel:"Syre er farlig for all marmor. Mellomfarget marmor kan bli ujevn i overflateglans ved feil rengj\u00f8ring over tid.",
      foerVar:["Impregner regelmessig \u2014 naturstein er por\u00f8s","Bruk gryteunderlag og skj\u00e6ref\u00f8l alltid","Fjern organiske flekker raskt \u2014 de setter seg dypt","Unng\u00e5 sure kj\u00f8kkenrens og eddik","T\u00f8rk etter vannkontakt"],
      qrKeys:["cc","te","sc","fd","gbs","ogp","rm"]
    },
    granitt: {
      display:"Granitt", hardhet:"Sv\u00e6rt h\u00f8y (Mohs 6\u20137)", varmeTaal:"Utmerket \u2014 naturlig varmebestandig",
      ph:"pH 7\u201310 (alkalisk)", imprTekst:P.impr+" hvert 1\u20132 \u00e5r \u2014 "+P.fd+" for m\u00f8rkere granitt",
      daglig:[P.cc+" \u2014 rask daglig rengj\u00f8ring, skjoldefri og matvareegnet","T\u00f8rk opp olje umiddelbart \u2014 uimpregnert granitt absorberer raskt"],
      ukentlig:[P.te+" ukentlig \u2014 rengj\u00f8ring, forsterket impregnering og glans i \u00e9n operasjon","Inspiser impregneringstilstand"],
      arlig:["Grunnrengj\u00f8ring med "+P.sc,P.impr+" \u2014 grundig p\u00e5f\u00f8ring etter rengj\u00f8ring",P.fd+" for m\u00f8rkere varianter"],
      flekk:[
        {type:"Organisk farge (kaffe, vin, frukt)", middel:P.gbs, pill:"warn"},
        {type:"Olje og fett (trukket inn)", middel:P.ogp+" \u2014 absorberingspasta, la virke til t\u00f8rt", pill:"warn"},
        {type:"Rustflekker", middel:"Akemi Rust fjerner gel \u2014 egnet for syreresistent granitt", pill:"danger"},
        {type:"Kalk og belegg", middel:P.sc+" kortvarig \u2014 skyll grundig", pill:"info"}
      ],
      advarsel:"Granitt er robust, men por\u00f8s uten impregnering. Olje trenger raskt inn og er vanskelig \u00e5 fjerne. Impregner regelmessig.",
      foerVar:["Impregner regelmessig \u2014 granitt er por\u00f8s naturstein","T\u00f8rk opp olje og fett umiddelbart","Bruk grytenderlag selv om granitt t\u00e5ler varme","Bruk skj\u00e6ref\u00f8l for \u00e5 beskytte polert overflate","L\u00f8ft \u2014 ikke skyv \u2014 tunge gjenstander"],
      qrKeys:["cc","te","sc","impr","fd","gbs","ogp"]
    },
    skifer: {
      display:"Skifer utend\u00f8rs", hardhet:"Middels (Mohs 3\u20135)", varmeTaal:"God, men frostsikker impregnering er kritisk",
      ph:"pH 7\u201310 (alkalisk)", imprTekst:P.fd+" (fremhever naturlig bl\u00e5/gr\u00e5 tone) \u2014 frostbestandig outdoor-variant, hvert \u00e5r om h\u00f8sten",
      daglig:["Fjern l\u00f8v, skitt og organisk materiale med b\u00f8rste og vann","Unng\u00e5 h\u00f8ytrykkspyler n\u00e6r kanter og spalteplaner"],
      ukentlig:[P.sc+" for regul\u00e6r grunnrengj\u00f8ring utend\u00f8rs","Kontroller etter kraftig regn eller frostperioder"],
      arlig:[P.fd+" outdoor-impregnering \u2014 anbefalt om h\u00f8sten f\u00f8r frost","Biologisk rens mot alger og mose","Inspiser for l\u00f8se fliser, sprekker eller frostskader"],
      flekk:[
        {type:"Organisk farge (alger, mose, blader)", middel:P.gbs, pill:"info"},
        {type:"Olje og fett", middel:P.ogp, pill:"warn"},
        {type:"Rustmerker", middel:"Akemi Rustfjerner (standard) \u2014 forsiktig bruk", pill:"danger"}
      ],
      advarsel:"Skifer og annen utend\u00f8rs stein er ofte spesielt utsatt for frost, alger og mose. Impregnering er kritisk for levetid og utseende. H\u00f8ytrykkspyler kan skade skiferen.",
      foerVar:["Impregner med frostbestandig variant hvert \u00e5r \u2014 helst om h\u00f8sten","Bruk biologisk steinrens mot alger og mose","Unng\u00e5 h\u00f8ytrykkspyler","Kontroller etter vinter for frostskader","Hold avl\u00f8p frie for organisk materiale"],
      qrKeys:["cc","sc","fd","gbs","ogp"]
    },
    silestone: {
      display:"Silestone", hardhet:"H\u00f8y (Mohs 6\u20137)", varmeTaal:"Moderat \u2014 bruk gryteunderlag (maks ~150\u00b0C)",
      ph:"T\u00e5ler pH 4\u201310", imprTekst:"Impregnering ikke n\u00f8dvendig \u2014 kvarts er ikke-por\u00f8st",
      daglig:[P.cc+" \u2014 sertifisert av Cosentino for bruk p\u00e5 Silestone, skjoldefri og rask","Fjern s\u00f8l umiddelbart, spesielt sterke kjemikalier"],
      ukentlig:[P.ic+" for grundig ukentlig rengj\u00f8ring","Inspiser fuge mot vask"],
      arlig:[P.ic+" for grundig grovrengjøring",P.qp+" 2\u20134 ganger per \u00e5r \u2014 frisk opp glansen p\u00e5 polert Silestone","Kontroller fuge og silikonkant \u2014 bytt ved behov"],
      flekk:[
        {type:"Organisk farge (kaffe, vin, frukt)", middel:P.gbs, pill:"info"},
        {type:"Metallavsetninger og aluminiumsriper", middel:PS_DESC, pill:"warn"},
        {type:"Kalkbelegg", middel:"Svak syre pH 4\u20135, kortvarig kontakt", pill:"info"}
      ],
      advarsel:"Unng\u00e5 langvarig kontakt med sterke syrer (pH under 4) og sterk lut (pH over 10). Ikke sett varmt direkte \u2014 kvarts-harpiksen t\u00e5ler ikke termisk sjokk.",
      foerVar:["Bruk alltid gryteunderlag og skj\u00e6ref\u00f8l","Unng\u00e5 hypokloritt (Klorin) over tid","T\u00f8rk opp kjemikalier umiddelbart (neglelakkfjerner etc.)","Bruk Akemi Quartz Polish 2\u20134 ganger i \u00e5ret for \u00e5 opprettholde glans","Godt vedlikehold av fuger forhindrer fuktskader"],
      qrKeys:["cc","ic","qp","gbs","ps"]
    },
    caesarstone: {
      display:"Caesarstone", hardhet:"H\u00f8y (Mohs 6\u20137)", varmeTaal:"Moderat \u2014 maks ~150\u00b0C anbefalt",
      ph:"T\u00e5ler pH 4\u201310", imprTekst:"Impregnering ikke n\u00f8dvendig",
      daglig:[P.cc+" \u2014 daglig lett rengj\u00f8ring, skjoldefri","T\u00f8rk s\u00f8l umiddelbart"],
      ukentlig:[P.ic+" ukentlig grundig rengj\u00f8ring","Inspiser fuger og skj\u00f8tpunkter"],
      arlig:[P.ic+" grovrengjøring",P.qp+" 2\u20134 ganger per \u00e5r \u2014 gjenoppretter og vedlikeholder glansen p\u00e5 Caesarstone","Kontroller fuge mot vask og vegg"],
      flekk:[
        {type:"Organisk farge", middel:P.gbs, pill:"info"},
        {type:"Metallavsetninger og aluminiumsriper", middel:PS_DESC, pill:"warn"},
        {type:"Blekk/maling", middel:"Isopropanol \u2014 kort kontakt, t\u00f8rk raskt", pill:"warn"}
      ],
      advarsel:"Unng\u00e5 Klorin og sterk lut. Ikke sett varmt direkte \u2014 termisk sjokk kan skade kvartsbindingen.",
      foerVar:["Bruk grytekluter og skj\u00e6ref\u00f8l","Unng\u00e5 kontakt med sterk lut og syre","T\u00f8rk kjemikalies\u00f8l umiddelbart","Bruk Akemi Quartz Polish 2\u20134 ganger i \u00e5ret for \u00e5 bevare glansen","Ikke hogge mot kanter"],
      qrKeys:["cc","ic","qp","gbs","ps"]
    },
    dekton: {
      display:"Dekton", hardhet:"Sv\u00e6rt h\u00f8y (Mohs 7\u20138)", varmeTaal:"Utmerket \u2014 t\u00e5ler opp mot 300\u00b0C",
      ph:"T\u00e5ler pH 2\u201312 (sv\u00e6rt robust)", imprTekst:"Impregnering ikke n\u00f8dvendig \u2014 tett, ikke-por\u00f8s overflate",
      daglig:[P.cc+" \u2014 sertifisert av Cosentino for Dekton","T\u00f8rk av for \u00e5 unng\u00e5 kalkmerker"],
      ukentlig:[P.ic+" for grundig ukentlig rengj\u00f8ring","Inspiser fuge og kanter"],
      arlig:[P.ic+" grovrengjøring","Kontroller fuge og silikonkant"],
      flekk:[
        {type:"Organisk farge", middel:P.gbs, pill:"info"},
        {type:"Metallavsetninger og aluminiumsriper", middel:PS_DESC, pill:"warn"},
        {type:"De fleste \u00f8vrige flekker", middel:P.ic+" er tilstrekkelig", pill:"info"}
      ],
      advarsel:"Dekton er sv\u00e6rt motstandsdyktig, men kan sprekke ved kraftig st\u00f8t mot kanter. Unng\u00e5 direkte slag.",
      foerVar:["Dekton er sv\u00e6rt vedlikeholdsvennlig \u2014 krever minimalt stell","Beskytt kanter mot harde slag","Bruk skj\u00e6ref\u00f8l for \u00e5 unng\u00e5 riper fra skarpe kniver","Kontroller fuger jevnlig"],
      qrKeys:["cc","ic","gbs","ps"]
    },
    porcelanosa: {
      display:"Porcelanosa keramikk", hardhet:"Sv\u00e6rt h\u00f8y \u2014 glasert overflate", varmeTaal:"Utmerket",
      ph:"T\u00e5ler pH 2\u201312", imprTekst:"Impregnering av flaten ikke n\u00f8dvendig \u2014 impregner fugene \u00e5rlig",
      daglig:[P.cc+" \u2014 egnet for keramikk og finmaterialer","Fugene er svakeste punkt \u2014 t\u00f8rk dem etter bruk"],
      ukentlig:[P.ic+" for grundig ukentlig rengj\u00f8ring av flate og fuge","Fugerens ved kalkbelegg i fuger"],
      arlig:[P.ic+" grovrengjøring","Impregnering av fuger (ikke flaten) \u2014 forhindrer misfarging","Inspiser fuge og bytt ved sprekker"],
      flekk:[
        {type:"Organisk farge", middel:P.gbs, pill:"info"},
        {type:"Metallavsetninger og aluminiumsriper", middel:PS_DESC, pill:"warn"},
        {type:"De fleste flekker", middel:P.ic+" er tilstrekkelig", pill:"info"}
      ],
      advarsel:"Fugene er keramikkbenkeplatens svakeste punkt. Misfargede, sprukne eller l\u00f8se fuger gir fuktskader og misfarging.",
      foerVar:["Vedlikehold fuger hyppig \u2014 impregner fuger hvert \u00e5r","T\u00f8rk fuger etter kontakt med vann","Bruk keramikkvennlig fugerens","Kontroller for l\u00f8s fuge \u2014 bytt om n\u00f8dvendig"],
      qrKeys:["cc","ic","gbs","ps"]
    },
    laminam: {
      display:"Laminam keramikk", hardhet:"Sv\u00e6rt h\u00f8y \u2014 meget tynn plate", varmeTaal:"Utmerket",
      ph:"T\u00e5ler pH 2\u201312", imprTekst:"Impregnering av flaten ikke n\u00f8dvendig \u2014 impregner fuger \u00e5rlig",
      daglig:[P.cc+" \u2014 egnet for alle keramiske overflater","T\u00f8rk fuger og kanter etter bruk"],
      ukentlig:[P.ic+" for grundig rengj\u00f8ring","Inspiser skj\u00f8ter og kanter n\u00f8ye \u2014 tynne plater er s\u00e5rbare ved kanter"],
      arlig:[P.ic+" grovrengjøring","Impregnering av fuger","Profesjonell kontroll av kantbehandling"],
      flekk:[
        {type:"Organisk farge", middel:P.gbs, pill:"info"},
        {type:"Metallavsetninger og aluminiumsriper", middel:PS_DESC, pill:"warn"},
        {type:"Vanlige flekker", middel:P.ic+" er tilstrekkelig", pill:"info"}
      ],
      advarsel:"Laminam-plater er sv\u00e6rt tynne \u2014 kantene er s\u00e5rbare. Unng\u00e5 harde slag mot kanter. Ikke bruk store flater som skj\u00e6reunderlag.",
      foerVar:["Ekstra forsiktig mot kanter \u2014 tynne plater kan sprekke ved slag","Vedlikehold fuger hyppig","Bruk skj\u00e6ref\u00f8l alltid","L\u00f8ft \u2014 ikke skyv \u2014 tunge gjenstander"],
      qrKeys:["cc","ic","gbs","ps"]
    }
  };

  var selMat = null;

  function fdvRenderMats() {
    var grid = document.getElementById("fdvMatGrid");
    if (!grid) return;
    for (var i = 0; i < MATS.length; i++) {
      var m = MATS[i];
      var div = document.createElement("div");
      div.className = "fdv-mat-card";
      div.id = "fdvMat_" + m.id;
      div.innerHTML = '<div class="fdv-mat-name">' + m.name + '</div><div class="fdv-mat-tag">' + m.tag + '</div>';
      (function(id) { div.onclick = function() { fdvSelectMat(id); }; })(m.id);
      grid.appendChild(div);
    }
  }

  function fdvSelectMat(id) {
    if (selMat) {
      var prev = document.getElementById("fdvMat_" + selMat);
      if (prev) prev.classList.remove("selected");
    }
    selMat = id;
    var cur = document.getElementById("fdvMat_" + id);
    if (cur) cur.classList.add("selected");
  }

  function fdvMakeQR(el, url, size) {
    try {
      new QRCode(el, { text: url, width: size, height: size, colorDark: "#1a1a1a", colorLight: "#ffffff", correctLevel: QRCode.CorrectLevel.M });
    } catch(e) { el.textContent = "QR"; }
  }

  function fdvSetStep(n) {
    for (var i = 1; i <= 3; i++) {
      var s = document.getElementById("fdvStep" + i);
      var p = document.getElementById("fdvP" + i);
      if (s) s.classList.toggle("active", i === n);
      if (p) p.className = "fdv-prog-seg" + (i < n ? " done" : i === n ? " active" : "");
    }
  }

  window.fdvGoStep1 = function() { fdvSetStep(1); };

  window.fdvGoStep2 = function() {
    if (!selMat) { alert("Velg et materiale f\u00f8rst."); return; }
    var m = null;
    for (var i = 0; i < MATS.length; i++) { if (MATS[i].id === selMat) { m = MATS[i]; break; } }
    document.getElementById("fdvSelName").textContent = m.name + " \u2014 " + m.tag;
    document.getElementById("fdvCustDate").value = new Date().toISOString().split("T")[0];
    fdvSetStep(2);
  };

  window.fdvGenerate = function() {
    var name = document.getElementById("fdvCustName").value || "Ikke oppgitt";
    var date = document.getElementById("fdvCustDate").value || new Date().toISOString().split("T")[0];
    var addr = document.getElementById("fdvCustAddr").value || "Ikke oppgitt";
    var proj = document.getElementById("fdvCustProj").value || "";
    var surf = document.getElementById("fdvCustSurf").value || "";
    var d = FDV[selMat];
    var mat = null;
    for (var i = 0; i < MATS.length; i++) { if (MATS[i].id === selMat) { mat = MATS[i]; break; } }
    var dateStr = new Date(date).toLocaleDateString("nb-NO", {day:"2-digit", month:"long", year:"numeric"});
    var refNo = "FDV-" + selMat.toUpperCase().substring(0,4) + "-" + Date.now().toString().slice(-4);

    var flekkRows = "";
    for (var f = 0; f < d.flekk.length; f++) {
      var fk = d.flekk[f];
      var pillTxt = fk.pill === "warn" ? "Forsiktig" : fk.pill === "danger" ? "Fagperson" : "Standard";
      flekkRows += '<tr><td>' + fk.type + '</td><td>' + fk.middel + ' <span class="fdv-pill fdv-pill-' + fk.pill + '">' + pillTxt + '</span></td></tr>';
    }

    var isNatur = mat.type === "naturstein";
    var imprRow = isNatur
      ? '<tr><td>Impregnering</td><td>' + d.imprTekst + '</td></tr>'
      : '<tr><td>Impregnering</td><td>Ikke n\u00f8dvendig \u2014 ikke-por\u00f8s overflate' + (mat.type === "keramikk" ? " (impregner fuger \u00e5rlig)" : "") + '</td></tr>';

    var qrItemsHtml = "";
    for (var q = 0; q < d.qrKeys.length; q++) {
      var k = d.qrKeys[q];
      qrItemsHtml += '<div class="fdv-qr-item"><div id="fdvQr_' + q + '" style="width:64px;height:64px"></div>'
        + '<div class="fdv-qr-label">' + (QRL_LABELS[k] || k) + '<br><a href="' + QRL[k] + '" target="_blank">Kj\u00f8p her</a></div></div>';
    }

    var liStr = function(arr) { var s = ""; for (var i=0;i<arr.length;i++) s += '<li>' + arr[i] + '</li>'; return s; };

    document.getElementById("fdvDoc").innerHTML =
      '<div class="fdv-doc-logo-row">'
      + '<div><div class="fdv-doc-brand">interiorstein.no<small>Benkeplater &amp; naturstein</small></div></div>'
      + '<div class="fdv-doc-meta"><strong>FDV-dokument</strong>Utstedt: ' + dateStr + '<br>Ref: ' + refNo + '</div>'
      + '</div>'
      + '<div class="fdv-doc-title">FDV \u2014 ' + d.display + '</div>'
      + '<div class="fdv-doc-subtitle">Forvaltning, drift og vedlikehold for steinbenkeplate</div>'
      + '<div class="fdv-sec"><div class="fdv-sec-title">Objekt og eier</div>'
      + '<table class="fdv-tbl">'
      + '<tr><td>Eier/kunde</td><td>' + name + '</td></tr>'
      + '<tr><td>Adresse</td><td>' + addr + '</td></tr>'
      + (proj ? '<tr><td>Prosjekt</td><td>' + proj + '</td></tr>' : '')
      + (surf ? '<tr><td>Overflate</td><td>' + surf + '</td></tr>' : '')
      + '<tr><td>Materiale</td><td>' + d.display + ' \u2014 ' + mat.tag + '</td></tr>'
      + '<tr><td>Hardhet</td><td>' + d.hardhet + '</td></tr>'
      + '<tr><td>Varmetoleranse</td><td>' + d.varmeTaal + '</td></tr>'
      + '<tr><td>Anbefalt pH</td><td>' + d.ph + '</td></tr>'
      + imprRow
      + '</table></div>'
      + '<div class="fdv-warn"><strong>Viktig: </strong>' + d.advarsel + '</div>'
      + '<div class="fdv-sec"><div class="fdv-sec-title">Rengj\u00f8rings- og pleieplan</div>'
      + '<div class="fdv-grid2">'
      + '<div class="fdv-box"><div class="fdv-box-title">Daglig</div><ul>' + liStr(d.daglig) + '</ul></div>'
      + '<div class="fdv-box"><div class="fdv-box-title">Ukentlig</div><ul>' + liStr(d.ukentlig) + '</ul></div>'
      + '</div>'
      + '<div class="fdv-box" style="margin-top:10px"><div class="fdv-box-title">\u00c5rlig</div><ul>' + liStr(d.arlig) + '</ul></div>'
      + '</div>'
      + '<div class="fdv-sec"><div class="fdv-sec-title">Flekkfjerner &amp; spesialmidler</div>'
      + '<table class="fdv-tbl"><thead><tr><th>Flekktype</th><th>Anbefalt tiltak og Akemi-produkt</th></tr></thead>'
      + '<tbody>' + flekkRows + '</tbody></table></div>'
      + '<div class="fdv-sec"><div class="fdv-sec-title">F\u00f8re-var-plan</div>'
      + '<div class="fdv-box"><ul>' + liStr(d.foerVar) + '</ul></div></div>'
      + '<div class="fdv-qr-sec">'
      + '<div class="fdv-qr-sec-title">Kj\u00f8p anbefalte produkter \u2014 skann QR-kode</div>'
      + '<div class="fdv-qr-grid">' + qrItemsHtml + '</div>'
      + '<div class="fdv-guide-box">'
      + '<div id="fdvQrGuide" style="width:64px;height:64px;flex-shrink:0"></div>'
      + '<div class="fdv-guide-text"><strong>Flekkfjerningsguide</strong>'
      + 'Detaljert guide for fjerning av alle flekktyper fra steinbenkeplater<br>'
      + '<a href="' + QRL.guide + '" target="_blank">' + QRL.guide + '</a></div>'
      + '</div></div>'
      + '<div class="fdv-footer">Dette FDV-dokumentet er generert av interiorstein.no og gjelder som vedlikeholdsanvisning for ovennevnte materiale. Alle anbefalte Akemi-produkter er tilgjengelige i v\u00e5r nettbutikk p\u00e5 interiorstein.no. Dokumentet er ikke en juridisk garanti.</div>';

    setTimeout(function() {
      for (var q = 0; q < d.qrKeys.length; q++) {
        var el = document.getElementById("fdvQr_" + q);
        if (el) fdvMakeQR(el, QRL[d.qrKeys[q]], 64);
      }
      var guideEl = document.getElementById("fdvQrGuide");
      if (guideEl) fdvMakeQR(guideEl, QRL.guide, 64);
    }, 80);

    fdvSetStep(3);
  };

  window.fdvPrint = function() {
    var d = FDV[selMat];
    var qrDataUrls = {};
    for (var q = 0; q < d.qrKeys.length; q++) {
      var el = document.getElementById("fdvQr_" + q);
      var canvas = el ? el.querySelector("canvas") : null;
      if (canvas) qrDataUrls["fdvQr_" + q] = canvas.toDataURL();
    }
    var guideEl = document.getElementById("fdvQrGuide");
    var guideCanvas = guideEl ? guideEl.querySelector("canvas") : null;
    if (guideCanvas) qrDataUrls["fdvQrGuide"] = guideCanvas.toDataURL();

    var content = document.getElementById("fdvDoc").innerHTML;
    var ids = Object.keys(qrDataUrls);
    for (var i = 0; i < ids.length; i++) {
      var id = ids[i];
      var re = new RegExp('<div id="' + id + '"[^>]*>[^<]*<\\/div>');
      content = content.replace(re, '<img src="' + qrDataUrls[id] + '" width="64" height="64" style="border:0.5px solid #ccc;border-radius:3px">');
    }

    var win = window.open("", "_blank");
    win.document.write('<!DOCTYPE html><html><head><meta charset="utf-8"><title>FDV \u2014 interiorstein.no</title>'
      + '<style>body{font-family:Georgia,serif;font-size:11.5px;color:#1a1a1a;margin:2cm;line-height:1.6}'
      + '.fdv-doc-logo-row{display:flex;justify-content:space-between;border-bottom:1px solid #ccc;padding-bottom:10px;margin-bottom:14px}'
      + '.fdv-doc-brand{font-size:15px;font-weight:bold}.fdv-doc-brand small{font-size:10px;font-weight:normal;color:#666;display:block}'
      + '.fdv-doc-meta{text-align:right;font-size:11px;color:#666}.fdv-doc-meta strong{color:#333;display:block}'
      + '.fdv-doc-title{font-size:17px;font-weight:bold;margin-bottom:3px}.fdv-doc-subtitle{font-size:12px;color:#666;margin-bottom:14px}'
      + '.fdv-sec{margin-bottom:14px}.fdv-sec-title{font-size:9.5px;text-transform:uppercase;letter-spacing:.08em;color:#888;border-bottom:.5px solid #ccc;padding-bottom:3px;margin-bottom:7px}'
      + '.fdv-tbl{width:100%;border-collapse:collapse}.fdv-tbl th{font-size:9.5px;text-transform:uppercase;background:#f5f5f2;padding:4px 7px;text-align:left}'
      + '.fdv-tbl td{font-size:11px;padding:5px 7px;border-bottom:.5px solid #e0e0e0;vertical-align:top}'
      + '.fdv-tbl td:first-child{color:#666;width:130px;font-weight:500}'
      + '.fdv-grid2{display:grid;grid-template-columns:1fr 1fr;gap:8px}'
      + '.fdv-box{background:#f8f7f5;border-radius:5px;padding:8px 10px}'
      + '.fdv-box-title{font-size:9.5px;text-transform:uppercase;color:#888;margin-bottom:5px}'
      + '.fdv-box ul{list-style:none;padding:0;display:flex;flex-direction:column;gap:3px}'
      + '.fdv-box li{font-size:11px;display:flex;align-items:flex-start;gap:5px}'
      + '.fdv-box li::before{content:"\\2014";color:#aaa;flex-shrink:0}'
      + '.fdv-warn{background:#fff8e1;border:.5px solid #ffe082;padding:8px 11px;border-radius:5px;margin-bottom:12px;font-size:11px}'
      + '.fdv-pill{font-size:9px;padding:1px 5px;border-radius:20px}'
      + '.fdv-pill-warn{background:#fff3cd;color:#856404}.fdv-pill-info{background:#d1ecf1;color:#0c5460}.fdv-pill-danger{background:#f8d7da;color:#721c24}'
      + '.fdv-ptag{font-size:9.5px;background:#eee;border:.5px solid #ccc;border-radius:3px;padding:0 4px;font-style:italic}'
      + '.fdv-ptag a{color:#333}'
      + '.fdv-qr-sec{margin-top:14px;padding-top:10px;border-top:.5px solid #ccc}'
      + '.fdv-qr-sec-title{font-size:9.5px;text-transform:uppercase;color:#888;margin-bottom:8px}'
      + '.fdv-qr-grid{display:flex;flex-wrap:wrap;gap:10px;margin-bottom:10px}'
      + '.fdv-qr-item{display:flex;flex-direction:column;align-items:center;gap:3px;width:72px}'
      + '.fdv-qr-label{font-size:8px;color:#888;text-align:center;line-height:1.3}'
      + '.fdv-guide-box{display:flex;align-items:center;gap:10px;background:#f8f7f5;border-radius:5px;padding:8px 10px}'
      + '.fdv-guide-text{font-size:11px}.fdv-guide-text strong{font-weight:bold;display:block;margin-bottom:2px}'
      + '.fdv-guide-text a{color:#333;font-size:9.5px}'
      + '.fdv-footer{font-size:9.5px;color:#aaa;border-top:.5px solid #ccc;padding-top:7px;margin-top:10px}'
      + 'a{color:#333}@media print{body{margin:1.5cm}}</style>'
      + '</head><body>' + content + '</body></html>');
    win.document.close();
    setTimeout(function() { win.print(); }, 400);
  };

  // Init on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fdvRenderMats);
  } else {
    fdvRenderMats();
  }

})();
